interface BrandsProps {
  index: number;
  name: string;
  image: string;
  icon: string;
  by: string;
  accentColor?: string;
  onClick?: () => void;
}

const Brands = ({
  index,
  name,
  image,
  icon,
  by,
  accentColor = "#7F29FF",
  onClick,
}: BrandsProps) => {
  return (
    <button
      type="button"
      className="flex flex-col items-center w-full text-left cursor-pointer focus:outline-none"
      key={index}
      onClick={onClick}
    >
      <div className="relative w-full aspect-[1/1.15] max-h-[180px] flex flex-col items-center rounded-[15px] border-[1.25px] border-[#E9E9E9] dark:border-gray-700 bg-white dark:bg-gray-800 pt-2 overflow-hidden hover:shadow-md transition-shadow">
        <img
          src={icon}
          alt=""
          className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] object-contain rounded-full"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
        <div
          className="absolute bottom-0 w-full h-[55%] rounded-t-[70px]"
          style={{ backgroundColor: accentColor }}
        />
        <img
          src={image}
          alt={name}
          className="w-[70%] max-w-[130px] h-auto aspect-square object-cover rounded-lg z-10 -mt-[12px]"
          onError={(e) => {
            e.currentTarget.src = icon;
          }}
        />
      </div>
      <span className="text-gray-900 dark:text-white font-urbanist text-xs md:text-sm font-medium mt-1 text-center line-clamp-1 w-full">
        {name}
      </span>
      {by ? (
        <span className="text-gray-500 dark:text-gray-400 font-urbanist text-[10px] md:text-xs font-normal text-center line-clamp-1 w-full">
          {by}
        </span>
      ) : null}
    </button>
  );
};

export default Brands;
